import { style } from "@vanilla-extract/css";
import { vars } from "../../../../plos/src/styles/theme.css";
import { breakpoints } from "../../styles/breakpoints";

export const loginContainer = style({
  display: "flex",
  flexDirection: "column-reverse",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space.l,
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.primaryFixed,
  padding: vars.space.m,

  "@media": {
    [`(min-width: ${breakpoints[3]})`]: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 0,
      padding: `${vars.space.m} ${vars.space.m} ${vars.space.m} ${vars.space["5xl"]}`,
    },
  },
});
